import { useCallback, useState } from "react";
import { useIdentityPrefill } from "../hooks/useIdentityPrefill";
import { useTwoStepChange } from "../hooks/useTwoStepChange";
import AuthProvider from "../services/auth/AuthProvider/Index";
import TwoStepChangePage from "./TwoStepChangePage";

const PhoneNumberChange = () => {
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [token, setToken] = useState("");
  const handleIdentity = useCallback((identity: any) => {
    setCurrentPhoneNumber(identity.phone_number);
  }, []);

  const { loadingIdentity } = useIdentityPrefill(handleIdentity);

  const {
    loading,
    requested,
    formErrors,
    handleRequest,
    handleConfirm,
  } = useTwoStepChange({
    requestUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/private/identity/me/phone-number-change-request`,
    confirmUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/private/identity/me/phone-number`,
    buildRequestBody: () => ({ phone_number: phoneNumber }),
    buildConfirmBody: () => ({ phone_number: phoneNumber, token }),
    requestSuccessMessage:
      "Your phone number change request has been successfully processed. Please take a moment to check your SMS messages for the confirmation token.",
    confirmSuccessMessage: "Your phone number has been successfully changed.",
    onConfirmSuccess: async () => {
      const identity = await AuthProvider.getIdentity();
      if (identity) {
        setCurrentPhoneNumber(identity.phone_number);
      }
      setPhoneNumber("");
      setToken("");
    },
  });

  return (
    <TwoStepChangePage
      title="Phone number change"
      breadcrumbLabel="Phone number change"
      currentLabel="Current phone number"
      currentValue={currentPhoneNumber}
      newLabel="New phone number"
      newFieldName="phone_number"
      newValue={phoneNumber}
      setNewValue={setPhoneNumber}
      newInputMask={(inputText: string) => {
        let result = inputText.replaceAll(/\D/g, "");

        if (!result.startsWith("+")) {
          result = "+" + result;
        }

        return result;
      }}
      confirmLabel="Confirmation token"
      confirmFieldName="token"
      tokenValue={token}
      setTokenValue={setToken}
      requested={requested}
      loading={loading}
      loadingIdentity={loadingIdentity}
      formErrors={formErrors}
      onRequest={handleRequest}
      onConfirm={handleConfirm}
      requestButtonLabel="Request phone number change"
      confirmButtonLabel="Confirm phone number change"
    />
  );
};

export default PhoneNumberChange;
